<template>
  <div
    class="galleryModule"
    :class="{
      'active' : isActive,
      'activeItem' : hasActiveItem,
    }"
  >
    <div class="cardListContainer"
      v-if="this.isActive">
      <GalleryCard
        id="slideAfter"
        v-if="currentItemIndex < galleryItems.length - 1"
        class="slide"
        :class="{'noClick': this.touch.swipeLock}"
        :item="galleryItems[currentItemIndex + 1]"
        :index="currentItemIndex + 1"
      />
      <GalleryCard
        id="slideCurrent"
        class="slide"
        :class="{
          'slideOut' : this.slideOut,
          'noClick': this.touch.swipeLock,
        }"
        :item="galleryItems[currentItemIndex]"
        :index="currentItemIndex"
        :style="styleCurrentSlide"
      />
      <GalleryCard
        id="slideBefore"
        v-if="currentItemIndex > 0"
        class="slide"
        :class="{
          'slideIn' : this.slideIn,
          'noClick': this.touch.swipeLock,
        }"
        :item="galleryItems[currentItemIndex - 1]"
        :index="currentItemIndex - 1"
        :style="styleLastSlide"
      />

      <div
        class="pagination"
      >
        {{ paginationItem }}
      </div>
      <div
        v-if="isActive && !hasActiveItem"
        class="arrows"
      >
        <div
          v-if="currentItemIndex > 0"
          class="prev"
          @click="nextIndex(-1)"
        ><PrevSVG/></div>
        <div
          v-if="currentItemIndex < galleryItems.length - 1"
          class="next"
          @click="nextIndex(1)"
        ><NextSVG/></div>
      </div>
    </div>

    <div
      class="preload"
      v-if="this.isActive && currentItemIndex < galleryItems.length - 4"
    >
      <img
        class="imgPreload"
        v-for="index in 2" :key="index"
        :src="galleryItems[currentItemIndex + 2 + index].images[0].path"
      >
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import GalleryCard from './GalleryCard.vue';
import PrevSVG from '../../../public/svg/prev.svg';
import NextSVG from '../../../public/svg/next.svg';

export default {
  name: 'galleryModule',
  components: {
    GalleryCard,
    PrevSVG,
    NextSVG,
  },
  props: {
  },
  data() {
    return {
      touch: {
        rafPending: false, // Request Animation Frame Pending
        startX: 0,
        startY: 0,
        endX: 0,
        endY: 0,
        deltaX: 0,
        deltaY: 0,
        scrollLock: false,
        swipeLock: false,
        threshDirection: 5,
      },
      slideIn: false,
      slideOut: false,
    };
  },
  computed: {
    ...mapGetters(['currentExhibit', 'currentPlayerGallery', 'currentGalleryItem', 'playerAudioActive']),
    isActive() {
      return !(!this.currentPlayerGallery);
    },
    galleryItems() {
      return this.isActive ? this.currentPlayerGallery.items : [];
    },
    currentItemIndex() {
      return this.currentPlayerGallery.currentItemIndex;
    },
    paginationItem() {
      if (!this.isActive) return '';
      return `${this.currentPlayerGallery.currentItemIndex + 1} / ${this.currentPlayerGallery.items.length}`;
    },
    styleCurrentSlide() {
      if (this.touch.swipeLock && this.touch.deltaX < 0
        && this.currentItemIndex < this.galleryItems.length - 1) {
        return {
          transform: `translateX(${this.touch.deltaX}px)`,
        };
      }
      return '';
    },
    styleLastSlide() {
      if (this.touch.swipeLock && this.touch.deltaX > 0) {
        return {
          transform: `translateX(calc(-100vw + ${this.touch.deltaX}px))`,
        };
      }
      return '';
    },
    hasTouch() {
      return this.$helper.hasTouch();
    },
    hasActiveItem() {
      return this.isActive && !(!this.currentGalleryItem);
    },
  },
  methods: {
    ...mapActions(['setPlayerGallery', 'setPlayerGalleryItem', 'setPlayerAudioActive']),
    clearGallery() {
    },
    nextIndex(direction) {
      // DO THIS IN MUTATIONS
      if (this.hasActiveItem) {
        this.setPlayerGalleryItem(null);
      }
      // stop players
      if (this.playerAudioActive) {
        this.setPlayerAudioActive(false);
        if (process.env.VUE_APP_DEBUG === 'on') console.log(' from GalleryModule nextIndex');
      }
      const nextItem = this.currentItemIndex + direction;
      if (this.slideOut
        || this.slideIn
        || nextItem < 0
        || nextItem > this.galleryItems.length - 1) {
        return;
      }

      if (direction > 0) {
        this.slideOut = true;
      } else {
        this.slideIn = true;
      }
      setTimeout(() => {
        this.currentPlayerGallery.currentItemIndex = nextItem; // //////////////// NOT GOOD! STORE?!
        this.slideOut = false;
        this.slideIn = false;

        // AND THIS ON currentItemIndex CHANGE USING WATCH
        const progress = ((this.currentPlayerGallery.currentItemIndex + 1)
          / this.galleryItems.length) * 100;

        if (progress > this.currentExhibit.progress) {
          this.currentExhibit.progress = progress;
        }
      }, 200);
    },
    // TOUCH interaction
    touchOnAnimFrame() {
      if (!this.touch.rafPending) {
        return;
      }
      this.touch.deltaX = this.touch.endX - this.touch.startX;
      this.touch.deltaY = this.touch.endY - this.touch.startY;

      if (Math.abs(this.touch.deltaX) > Math.abs(this.touch.deltaY)
        + this.touch.threshDirection && !this.touch.swipeLock) {
        this.touch.swipeLock = true;
      } else if (Math.abs(this.touch.deltaY) > Math.abs(this.touch.deltaX)
        + this.touch.threshDirection && !this.touch.swipeLock) {
        this.touch.scrollLock = true;
      }
      this.touch.rafPending = false;
    },
    touchstart(e) {
      if (this.hasTouch) {
        this.$el.ontouchmove = (event) => { this.touchmove(event); };
        document.ontouchend = () => { this.touchend(); };

        this.touch.startX = e.touches[0].clientX;
        this.touch.startY = e.touches[0].clientY;
      } else {
        this.$el.onmousemove = (event) => { this.touchmove(event); };
        document.onmouseup = () => { this.touchend(); };

        this.touch.startX = e.clientX;
        this.touch.startY = e.clientY;
      }

      this.touch.endX = this.touch.startX;
      this.touch.endY = this.touch.startY;
    },
    touchmove(e) {
      if (this.touch.startX < 1) {
        return;
      }
      if (this.hasTouch) {
        this.touch.endX = e.touches[0].clientX;
        this.touch.endY = e.touches[0].clientY;
      } else {
        this.touch.endX = e.clientX;
        this.touch.endY = e.clientY;
      }
      if (this.touch.rafPending) {
        return;
      }
      this.touch.rafPending = true;
      window.requestAnimationFrame(() => { this.touchOnAnimFrame(); });
    },
    touchend() {
      if (this.touch.swipeLock) {
        if (this.touch.endX < this.touch.startX - this.touch.threshDirection) {
          this.nextIndex(1); // USE EVENT onSwipeLeft
        } else if (this.touch.endX > this.touch.startX + this.touch.threshDirection) {
          this.nextIndex(-1);
        }
      }
      this.touch.startX = 0;
      this.touch.startY = 0;
      this.touch.endX = 0;
      this.touch.endY = 0;
      this.touch.deltaX = 0;
      this.touch.deltaY = 0;
      this.touch.scrollLock = false;
      this.touch.swipeLock = false;

      if (this.hasTouch) {
        this.$el.ontouchmove = null;
        document.ontouchend = null;
      } else {
        this.$el.onmousemove = null;
        document.onmouseup = null;
      }
    },
  },
  watch: {
    isActive(newValue) {
      if (newValue) {
        if (process.env.VUE_APP_DEBUG === 'on') console.log('Open Gallery');
      } else if (process.env.VUE_APP_DEBUG === 'on') {
        console.log('Close Gallery');
      }
    },
    /* currentGalleryItem(newValue) {
      if (newValue !== null) {
        console.log(this.currentItemIndex);
        this.currentPlayerGallery.currentItemIndex = parseInt(newValue.id, 10) - 1;
        this.nextIndex(1);
      }
    }, */
  },
  mounted() {
    if (this.hasTouch) {
      this.$el.ontouchstart = (event) => { this.touchstart(event); };
    } else {
      this.$el.onmousedown = (event) => { this.touchstart(event); };
    }
  },
  beforDestroy() {
    if (this.hasTouch) {
      this.$el.ontouchstart = null;
    } else {
      this.$el.onmousedown = null;
    }
  },
};
</script>

<style lang="scss" scoped>
.galleryModule {
  position: absolute;
  top: 14vh;
  top: calc(var(--vh, 1vh) * 14);
  width: 100vw;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background-color: #fff;
  background-color: var(--main-background-color);
  transform: translateY(0);
  transition: transform .5s ease;

  &.hidden {
    transform: translateY(86vh);
    transform: translateY(calc(var(--vh, 1vh) * 86));
  }

  &.activeItem {
    transform: translateY(-16vh);
    transform: translateY(calc(var(--vh, 1vh) * -16));
  }

  .cardListContainer {
    position: relative;
    width: 100vw;
    height: 86vh;
    height: calc(var(--vh, 1vh) * 86);
    font-weight: bold;
    text-align: center;
    color: white;

    .slide {
      position: absolute;
      top: 0;
      left: 0;
      width: 100vw;
      background-color: #fff;
      background-color: var(--main-background-color);
    }

    .slide:not(.noTransition){ /* prevent Transition while draging */
    }

    #slideCurrent {
      transform: translateX(0);

      &.slideOut {
        transform: translateX(-100vw);
        transition: transform .2s ease;
      }
    }
    #slideBefore {
      transform: translateX(-100vw);

      &.slideIn {
        transform: translateX(0);
        transition: transform .2s ease;
      }
    }
  }

  .pagination {
    position: absolute;
    top: 3vh;
    top: calc(var(--vh, 1vh) * 3);
    width: 100%;
    height: 5vh;
    height: calc(var(--vh, 1vh) * 5);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2em;
  }

  .arrows {
    position: absolute;
    top: 38%;
    width: 100%;

    svg {
      width: 100%;
      height: 100%;
      stroke: #fff;
    }

    .prev {
      position: absolute;
      top: 0;
      left: 3vw;
      width: 30px;
      height: 30px;
      padding: 5px;
    }
    .next {
      position: absolute;
      top: 0;
      right: 3vw;
      width: 30px;
      height: 30px;
      padding: 5px;
    }
  }

  .preload {
    position: fixed;
    top: - 1000px;
    left: - 3000px;
    .imgPreload {
      position: absolute;
      width: 1px;
      height: 1px;
      display: inline;
      overflow: hidden;
    }
  }
}
@media only screen and (orientation : landscape) {
  .galleryModule {
    top: 14vh;
    top: calc(var(--vh, 1vh) * 14);

    &.activeItem {
      transform: translateY(0);
    }

    .cardListContainer {
      order: 0;
      width: 62vw;
      overflow: visible;

      #slideCurrent {
        &.slideOut {
          transform: translateX(-62vw);
        }
      }
      #slideBefore {
        transform: translateX(-62vw);
      }

      .slide {
        width: 62vw;
        height: 86vh;
        height: calc(var(--vh, 1vh) * 86);
      }
    }

    .pagination {
      top: 33vh;
      left: 50vw;
      font-size: 1.1em;
      color: var(--main-elements-color);
    }
  }
  @media only screen and (min-aspect-ratio: 3/2) { // and (max-width : 900px)
    .galleryModule {
      .cardListContainer {
        width: 38vw;

        #slideCurrent {
          &.slideOut {
            transform: translateX(-38vw);
          }
        }
        #slideBefore {
          transform: translateX(-38vw);
        }

        .slide {
          width: 38vw;
        }
      }

      .pagination {
      }
    }
  }
}
</style>
